import axios from 'axios'
import Excel from 'exceljs'
import FileSaver from 'file-saver'
import {
    START_LOADING,
    STOP_LOADING,
    SET_AVAILABLE_FC,
    SET_MY_FC,
    SET_PAST_FC,
    SET_CART_FC,
    ADD_DETAILS_FC
} from '../reducers/types'
import {success, error} from '../components/common/toast'
import {ROOT_URL} from './config'

export function getAvailableFancyColour() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Fancy Colour Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/available`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Fancy Colour Inventory'}))
        .then(res => {
            dispatch({type: SET_AVAILABLE_FC, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function getCurrentFancyColour() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Fancy Colour Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/customer`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Fancy Colour Inventory'}))
        .then(res => {
            dispatch({type: SET_MY_FC, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function getPastFancyColour() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Fancy Colour Inventory'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/past`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Fancy Colour Inventory'}))
        .then(res => {
            dispatch({type: SET_PAST_FC, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function addToFancyColourCart(parcelNames) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Updating Fancy Colour'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/cart_stones`,
            data: {parcelNames: Array.isArray(parcelNames) ? parcelNames : [parcelNames]}
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Updating Fancy Colour'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function getFancyColourCart() {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Cart'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/cart`
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Cart'}))
        .then(res => {
            dispatch({type: SET_CART_FC, payload: res.data});
        })
        .catch(err => {
            error(err)
            return Promise.reject(err);
        })
    }
}

export function removeFromFancyColourCart(parcelNames) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Updating Cart'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/uncart_stones`,
            data: {parcelNames: Array.isArray(parcelNames) ? parcelNames : [parcelNames]}
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Updating Cart'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function requestFancyColour(parcelNames, remarks) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Sending Request'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/request_stones`,
            data: {
                parcelNames: Array.isArray(parcelNames) ? parcelNames : [parcelNames],
                remarks: remarks ? remarks : undefined
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Sending Request'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function returnFancyColour(parcelNames, remarks) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Signalling Return'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/return`,
            data: {
                parcelNames: Array.isArray(parcelNames) ? parcelNames : [parcelNames],
                remarks: remarks ? remarks : undefined
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Signalling Return'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function sellFancyColour(parcelNames, remarks) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Making Sale'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/sale`,
            data: {
                parcelNames: Array.isArray(parcelNames) ? parcelNames : [parcelNames],
                remarks: remarks ? remarks : undefined
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Making Sale'}))
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function getFancyColourDetails(parcelName) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Fancy Colour'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/details`,
            data: {parcelName}
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Fancy Colour'}))
        .then(res => {
            dispatch({type: ADD_DETAILS_FC, payload: res.data});
        })
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function getFancyColourCert(parcelName) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Retrieving Cert'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/cert`,
            data: {parcelName}
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Retrieving Cert'}))
        .then(res => {
            return res.data
        })
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function deleteLastFancyColourHistory(historyRow) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Cancelling History'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/undo`,
            data: {
                parcelName: historyRow.parcelName,
                action: historyRow.type
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Cancelling History'}))
        .then(res => {
            dispatch({type: ADD_DETAILS_FC, payload: res.data});
        })
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

export function backdateFancyColourHistory(historyRow, newDate) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Changing Date'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/fancycolour/change_date`,
            data: {
                parcelName: historyRow.parcelName,
                action: historyRow.type,
                newDate
            }
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Changing Date'}))
        /*.then(res => {
            dispatch({type: ADD_DETAILS, payload: res.data});
        })*/
        .catch(err => {
            error(err);
            return Promise.reject(err);
        })
    }
}

/*export function lgSimilarStones(params) {
    return function(dispatch) {
        dispatch({type: START_LOADING, payload: 'Checking similar diamonds'})
        return axios({
            method: 'POST',
            url: `${ROOT_URL}/labgrown/similar`,
            data: params
        })
        .finally(() => dispatch({type: STOP_LOADING, payload: 'Checking similar diamonds'}))
        .then(({data}) => data)
    }
}*/

export function excelFCExport(stones, extraColumns, {hideTier} = {}) {
    return function(dispatch) {
        const workbook = new Excel.Workbook();
        workbook.creator = 'Dialog';
        workbook.created = new Date();
        const sheet = workbook.addWorksheet('Dialog Fancy Colour Inventory');
        const linkFmt = {underline: true, color: {argb: 'FF0000FF'}}
        const twoDecimals = x => Number(x).toFixed(2)
        let columns = [
            {header: 'Parcel Name', key: 'parcelName', width: 19},
            {header: 'Lab', key: 'lab', width: 15},
            {header: 'Cert Number', key: 'certNo', width: 18, excelCell: (cert, {lab}) => lab==='GIA' ? {text: cert, hyperlink: `https://www.gia.edu/report-check?reportno=${cert}`} : cert},
            {header: 'Weight', key: 'weight', width: 8, style: {numFmt: '0.00#'}},
            {header: 'Shape', key: 'shapeName', width: 8},
            {header: 'Colour', key: 'colourText', width: 18},
            {header: 'Clarity', key: 'clarity', width: 8},
            {header: 'Fluor', key: 'fluorescence', width: 8},
            {header: 'Cut', key: 'cut', width: 8},
            {header: 'Pol', key: 'polish', width: 8},
            {header: 'Sym', key: 'symmetry', width: 8},
            {header: 'Table %', key: 'tablePct', width: 8},
            {header: 'Depth %', key: 'depthPct', width: 8.5},
            {header: 'Measurements', key: 'length', width: 14.5, excelCell: (value, stone) => `${twoDecimals(stone.length)}-${twoDecimals(stone.width)}\u00d7${twoDecimals(stone.height)}`},
            {header: 'Ratio', key: 'width', width: 8, excelCell: (value, stone) => twoDecimals(Math.max(stone.length,stone.width) / Math.min(stone.length, stone.width))},
            ...(hideTier ? [] : [{header: 'Tier', key: 'tier', width: 9.8}]),
            //{header: 'RAP', key: 'displayRap', width: 10},
            //{header: 'RAP %', key: 'displayRapPercent', width: 10},
            {header: 'Price', key: 'total', width: 12, style: {numFmt: '$#,##0.00'}},
            {header: 'Status', key: 'status', width: 12},
            {header: 'V360', key: 'photoUrl', width: 12, excelCell: value => ({text: 'Image/Video', hyperlink: value})}
        ]
        if (Array.isArray(extraColumns) && extraColumns.length) {
            columns = columns.concat(extraColumns.map(col => ({
                header: col.Header,
                key: col.accessor,
                width: col.minWidth / 5,
                excelCell: col.excelCell
            })))
        }
        sheet.columns = columns;
        sheet.addRows(stones);

        for (let col of columns.filter(c => c.excelCell)) {
            const fileColumn = sheet.getColumn(col.key);
            if (!fileColumn) continue;
            fileColumn.eachCell((cell, row) => {
                if (row > 1 && cell.value) {
                    const newValue = col.excelCell(cell.value, stones[row-2]);
                    cell.value = newValue;
                    if (newValue.hyperlink) cell.font = linkFmt
                }
            })
        }

        sheet.views = [{ state: 'frozen', ySplit: 1 }]
        return workbook.xlsx.writeBuffer()
        .then(buffer => {
            FileSaver.saveAs(new Blob([buffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), `Dialog Export.xlsx`);
        })
    }
}